











import { Component, Prop, Vue } from 'vue-property-decorator';
import { periodYears, uniqueDescendingYears } from '@/app/paycheck-period';

@Component
export default class YearSelect extends Vue {
  // Pass the year from route query params, so that changing it makes sense
  @Prop({ type: Number, required: true }) private year!: number;
  private years: number[] = [];

  private async created() {
    const years = await periodYears();
    this.years = uniqueDescendingYears([ ...years, this.year ]);
  }

  private addYearToUrl(year: number): void {
    if (this.year == year) return;

    this.$router.push({
      name: this.$route.name!,
      query: { ...this.$route.query, year: String(year) },
    });
  }
}
